import usePrivateAxios from "@/common/api/usePrivateAxios";
import { ErrorResponse } from "@/common/types/errorResponse";
import { UpdatePermissionValidationSchema } from "@/features/permissions/schemas/create.schema";
import { useMutation } from "@tanstack/react-query";

interface UseUpdateTmaisPermissionProps {
  id: string
  onSuccess: () => void
  onError: (error: ErrorResponse) => void
}

const useUpdateTmaisPermission = ({id, onSuccess, onError}: UseUpdateTmaisPermissionProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['updateTmaisPermission'],
    mutationFn: async (form: UpdatePermissionValidationSchema) => privateAxios.put(`/tmais/permissions/${id}`, form),
    onSuccess,
    onError
  });
}

export default useUpdateTmaisPermission
